import React, { useEffect, useState, useRef } from "react";
import { nowISO } from "../../utils";
import { SectionCard } from "../study/course/SectionCard";
import Button from "../Button";
import { makeStyles } from "tss-react/mui";
import { useStudy } from "../../pages/study/hooks";
import { addAssignmentActivitiesByCourseAndAssignee } from "../../store/study/studyBaseApi";
import RecapVideoPlayer from "./RecapVideoPlayer";
import CompleteChapterButton from "./CompleteChapterButton";
import { Box } from "@mui/material";
import { useCourse } from "../../pages/course/hooks";

const defaultVideoUrl = 'https://s3.ap-south-1.amazonaws.com/azvasa-lms-cdn-dev/IR-SERVICE//0ab87bcf-59b0-443b-931c-f675ab9ea50c_9.Concept%20Video%20-%20Story%20elements.mp4'

const useStyles = makeStyles()((theme) => ({
    actionBtn: {
        marginBottom: theme.spacing(2),
        position: 'absolute',
        left: '50%',
        bottom: '-5vh',
        transform: 'translateX(-50%)',
        // marginTop: '-34px',
        // justifyContent: "center",
        // display: "flex"
    },
}));

export default function Recap({ data, courseId, sectionId, onComplete, onNextChapter }) {
    // const { profile } = useStudy();
    const [videoUrl, setVideoUrl] = useState("");
    // const [chapter, setChapter] = useState({});
    const chapterId = data?.chapterId

    // const videoRef = useRef(null);
    const videoPlaybackStart = useRef(null);

    const onPlaybackStarted = () => {
        videoPlaybackStart.current = nowISO();
    }

    const getStartTime = () => {
        return videoPlaybackStart.current || nowISO();
    }

    useEffect(() => {
        // setChapter(data);
        setVideoUrl(data?.contentURL || defaultVideoUrl);

    }, [data]);

    if (!videoUrl) return <></>;

    return (
        <Box sx={{}}>
            <RecapVideoPlayer url={videoUrl} onPlay={onPlaybackStarted} />
            <CompleteAction getStartTime={getStartTime} {...{ data, courseId, chapterId, sectionId, onComplete, onNextChapter }} />
        </Box>
    )
}

function CompleteAction({ onComplete, getStartTime, data, courseId, chapterId, sectionId, onNextChapter }) {
    const { classes } = useStyles();
    const { profile, recapCompleted } = useStudy();
    const { lastSectionChapter } = useCourse();
    const [completed, setCompleted] = React.useState(false);

    const handleComplete = async () => {
        setCompleted(true);

        try {
            await addAssignmentActivitiesByCourseAndAssignee({
                params: { courseId, assigneeId: profile.id }, body: {
                    assigneeId: profile.id, courseId, sectionId,
                    chapterId: chapterId,
                    endTime: nowISO(),
                    startTime: getStartTime(),
                    type: 'CHAPTER_COMPLETE',
                }
            });
        } catch (e) {
            console.error(e);
        }

        // Signal completion only AFTER the CHAPTER_COMPLETE write above — the
        // session-gate verdict (retake vs celebrate) refetches the gate and
        // must see the finished attempt.
        if (onComplete && typeof onComplete === "function") {
            onComplete();
        }

        try {
            if (!lastSectionChapter.chapter) {
                await onNextChapter();
            }
        } catch (e) {
            console.error(e);
        } finally {
            setCompleted(false)
        }
    }

    return (
        <div >
            {courseId && sectionId && !completed && <div className={classes.actionBtn}>
                <CompleteChapterButton onClick={handleComplete} />
            </div>}
        </div>
    )
}